<svelte:head>
  <title>{charity?.name || 'Charity'} | A Good Thing</title>
</svelte:head>
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->

<div class="block is-size-7">
  <a href={$url('../..')}> &lt; Back to charities</a>
</div>

{#if charity}
  <!-- Main container -->
  <nav class="level">
    <!-- Left side -->
    <div class="level-left level-can-wrap">
      <div class="level-item level-can-wrap">
        <h2 class="title">{charity.name}</h2>
      </div>
    </div>

    <!-- Right side -->
    <div class="level-right">

      {#if $appState.user?.isFullAdmin || $appState.user?.isFullCharityAdmin}

        {#if !charity.isOwnershipVerified}
          <button
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmVerifyOwnership,
                props: { id, gotoPath: 'admin/charity' }
              };
            }}
            class="button is-primary"
            aria-haspopup="true"
            aria-controls="dropdown-menu">
            Verify ownership
          </button>
        {/if}

        {#if !$appState.user?.charity && !$appState.user?.company}
          &nbsp;
          <button on:click={startAccess} class="button"> Act as charity </button>
        {/if}

        {#if user}
          &nbsp;

          <!-- svelte-ignore a11y-missing-attribute -->
          <a
            class="button is-secondary"
            on:click={() => {
              $uiState.activeModal = {
                component: ConfirmDeleteUser,
                props: { userId }
              };
            }}>Delete user</a>
        {/if}

        {#if $appState.user?.charity === id}
          &nbsp;
          <button on:click={endAccess} class="button is-primary">
            Stop acting as charity
          </button>
        {/if}

        {#if user}
          &nbsp;

          <div class="dropdown is-hoverable is-right">
            <div class="dropdown-trigger">
              <button
                class="button"
                aria-haspopup="true"
                aria-controls="dropdown-menu">
                <span>More</span>
                <span class="icon is-small">
                  <i class="mdi mdi-chevron-down" aria-hidden="true" />
                </span>
              </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <!-- svelte-ignore a11y-missing-attribute -->
                <a
                  on:click={() => {
                    $uiState.activeModal = {
                      component: ConfirmVerifyEmail,
                      props: { userId }
                    };
                  }}
                  class="dropdown-item">
                  Verify email
                </a>
              </div>
            </div>
          </div>
        {/if}

        &nbsp;

      {/if}

      <!-- svelte-ignore a11y-missing-attribute -->
      <a
        class="button is-secondary"
        on:click={() => {
          showNotes = !showNotesPanel;
        }}
        ><span class="icon" class:has-text-info={showNotesPanel}>
          <i class="mdi mdi-message" />
        </span></a>
    </div>
  </nav>

  <div class="columns">
    <div class="column">
      <EditableTagList
        type=charity
        bind:tags={charity.tags}
        on:changed={() => {
          saveTags();
        }} />

      {#if charity.deactivated}
        <article class="message is-danger">
          <div class="message-body">Deactivated.</div>
        </article>
      {/if}

      <div class="tabs">
        <ul>
          <PageTab page="details" label="Details" />
          <PageTab page="requests" label="Requests" />
          <PageTab page="needs" label="Needs" />
        </ul>
      </div>

      <slot />
    </div>

    <div
      class="column is-4"
      class:is-hidden={!showNotesPanel}>
      <div class="box">
        <div class="block">Admin notes</div>
        <NoteList {id} objectType="charity" on:loaded={(ev) => { initialNoteCount = ev.detail.noteCount }} />
      </div>
    </div>
  </div>
{/if}

<script lang="ts">
  export let id: string;

  import _ from 'lodash';
  import { goto, url, params } from '@sveltech/routify';
  import { appState } from '../../../../lib/appState';
  import { uiState } from '../../../../lib/uiState';

  import ConfirmVerifyEmail from './_components/ConfirmVerifyEmail.svelte';
  import ConfirmVerifyOwnership from './_components/ConfirmVerifyOwnership.svelte';
  import ConfirmDeleteUser from '../../_components/ConfirmDeleteUser.svelte';

  import PageTab from '../../../_components/PageTab.svelte';
  import NoteList from '../../_components/NoteList.svelte';
  import EditableTagList from '../../_components/EditableTagList.svelte';

  id = $params['id'];

  let charity: Charity_v2;
  let user: User_v1 | undefined;
  let userId: string | undefined;

  let showNotes: undefined | boolean;
  let initialNoteCount = 0;
  $: showNotesPanel = showNotes !== undefined ? showNotes : initialNoteCount > 0;

  let firebase = window.firebase;

  get();

  async function get() {
    firebase
      .firestore()
      .collection('charities_v2')
      .doc(id)
      .onSnapshot((doc) => {
        charity = doc.data() as Charity_v2;

        // backwards compat
        if (!charity.tags) {
          charity.tags = [];
        }
      });

    firebase
      .firestore()
      .collection('users_v1')
      .where('charity', '==', id)
      .onSnapshot((snap) => {
        const doc = _.find(snap.docs, (doc) => !doc.data().isAdmin);
        if (doc) {
          userId = snap.docs[0].id;
          user = snap.docs[0].data() as User_v1;
        } else {
          userId = undefined;
          user = undefined;
        }
      });
  }

  async function saveTags() {
    await firebase.functions().httpsCallable('api-account-updatecharity')({
      id,
      charity
    } as UpdateCharityParams);
  }

  function startAccess() {
    firebase
      .firestore()
      .collection('users_v1')
      .doc($appState.auth_user.email)
      .update({
        charity: id
      })
      .then((doc) => {
        $goto('/charity');
      });
  }

  function endAccess() {
    firebase
      .firestore()
      .collection('users_v1')
      .doc($appState.auth_user.email)
      .update({
        company: firebase.firestore.FieldValue.delete(),
        charity: firebase.firestore.FieldValue.delete()
      })
      .then(() => {
        $appState.user!.company = undefined;
        $appState.user!.charity = undefined;
      });
  }
</script>
